<template>
  <div class="signature-verify-editor">
    <!--
      Circus Browser
    -->
    <api-browser ref="circusBrowser" :api="root.signatureVerify.apiListing" backdrop="true">
      <div slot="header" class="modal-header py-3">
        <h4 class="modal-title"><i class='fad fa-file-contract fa-lg mr-2'></i> {{ 'İmza Sirküsü Seç'|trans }}</h4>
        <button type="button" class="close" @click="$refs.circusBrowser.close()">×</button>
      </div>

      <template slot="filters" slot-scope="props">
        <div class="input-group-prepend">
          <input type="text" class="form-control rounded-0" v-model="props.params.filters.verification_id" :placeholder="'Sirkü ara..'|trans">
        </div>
        <select class="custom-select rounded-0" v-model="props.params.orderBy">
          <option value="verification_id,asc">{{ 'Kimlik'|trans }} A-Z</option>
          <option value="verification_id,desc">{{ 'Kimlik'|trans }} Z-A</option>
          <option value="created_at,asc">{{ 'Oluşma Tarihi'|trans }} A-Z</option>
          <option value="created_at,desc">{{ 'Oluşma Tarihi'|trans }} Z-A</option>
        </select>
      </template>

      <table slot="items" slot-scope="props" class="table table-hover mb-0">
        <tbody>
          <tr class="pointer" v-for="item in props.items">
            <td @click="onSelectCircus(item)">{{ item.verification_id }}</td>
            <td @click="onSelectCircus(item)">
              <span class="badge badge-success" v-if="item.status">{{ 'Aktif'|trans }}</span>
              <span class="badge badge-danger" v-else>{{ 'Pasif'|trans }}</span>
            </td>
            <td @click="onSelectCircus(item)">{{ item.service_version }}</td>
            <td @click="onSelectCircus(item)">{{ item.created_at|formatDate }}</td>
          </tr>
        </tbody>
      </table>
    </api-browser>

    <!--
      Ratio Result
    -->
    <div class="modal" ref="ratioModal">
      <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
          <div class="modal-header py-3 bg-success justify-content-center align-items-center">
            <h5 class="modal-title">{{ 'Benzerlik Oranı Karşılaştırma Sonucu'|trans }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body d-flex justify-content-center align-items-center">
            <span class="ratio-result">{{ ratioResult }}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiBrowser from "../../Transaction/ApiBrowser";

export default {
  name: "SignatureVerifyCheck",
  components: {ApiBrowser},
  computed:{
    root() {
      return this.$parent.$parent;
    }
  },
  filters: {
    formatDate(val) {
      return (new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric'
      }).format(new Date(Date.parse(val))));
    }
  },
  data: () => {
    return {
      signature: null,
      ratioResult: -1
    }
  },
  methods: {
    /**
     * Select Signature & Open Circus Panel
     */
    show(signature) {
      this.signature = signature;
     this.$refs.circusBrowser.open();
    },

    /**
     * Send Verify Service
     */
    onSelectCircus(circus) {
      $.ajax({
        type: "POST",
        url: this.root.signatureVerify.apiRatio,
        dataType: 'json',
        contentType: "application/json",
        data: JSON.stringify({
          'verification_id': circus.verification_id,
          'signature': this.signature.biometricData
        }),
        beforeSend: () => {
          this.$refs.circusBrowser.setProgress(true);
        },
        success: (r) => {
          this.$refs.circusBrowser.setProgress(false);
          this.ratioResult = r.threshould;
          $(this.$refs.ratioModal).modal();
        },
      });
    }
  }
}
</script>

<style lang="scss">
.signature-verify-editor {
  .modal-header{
    background: var(--sidebar-selected);
    color: #FFF;
  }

  .ratio-result {
    font-size: 2rem;
  }
}
</style>
